import { IPagination, IPaginationDTO } from '@/models/pagination.model';

export enum FeedbackEndpoints {
  FEEDBACKS = '/feedbacks',
  MANAGERS = '/feedbacks/managers',
}

export enum FeedbackType {
  CONTACT_PAGE = 'contact_page',
  PARTNER_SUPPORT = 'partner_support',
  PRODUCT_AVAILABILITY = 'product_availability',
  ORDER_SUPPORT = 'order_support',
  POTENTIAL_PARTNER = 'potential_partner',
}

export enum FeedbackStatus {
  NEW = 'new',
  CONVERTED_TO_ORDER = 'converted_to_order',
  CONSULTATION = 'consultation',
  NO_RESPONSE = 'no_response',
  CANCELLED = 'cancelled',
}

export enum OrderSupportRequestType {
  ORDER_PRODUCTS_ISSUE = 'order_products_issue',
  ORDER_MISSING_PART = 'order_missing_part',
  PRODUCT_DAMAGED = 'product_damaged',
  ORDER_DELAYED = 'order_delayed',
  PAYMENT_ISSUE = 'payment_issue',
  ADDRESS_CHANGE = 'address_change',
  ORDER_CANCEL = 'order_cancel',
  PRODUCT_RETURN_ISSUE = 'product_return_issue',
  WARRANTY_SERVICE = 'warranty_service',
  OTHER_ISSUE = 'other_issue',
}

export interface IPotentialPartnerInfo {
  organization_tax_code: string;
  position: string;
  sphere_of_activity: string;
  title: string;
}

export interface IFeedback {
  id: string;
  type: FeedbackType;
  comment?: string;
  phone?: string;
  email?: string;
  name?: string;
  status: FeedbackStatus;
  created_at: string;
  manager?: {
    id: string;
    full_name: string;
  } | null;
  model?: {
    title: string;
    id: string;
    name: string;
    number: number;
  };
  request_type?: OrderSupportRequestType;
  feedback_info?: IPotentialPartnerInfo;
}

// ----------------- DTOs ----------------

export interface IGetFeedbacksDTO extends IPaginationDTO {
  type: FeedbackType;
  name?: string;
  phone?: string;
  status?: FeedbackStatus;
  date_from?: string;
  date_to?: string;
  model_name?: string;
  model_id?: string;
  comment?: string;
  title?: string;
  organization_tax_code?: string;
  manager_id?: string;
}

export interface IChangeFeedbackStatusDTO {
  id: string;
  type: FeedbackType;
  status: FeedbackStatus;
}

export interface IDeleteFeedbackDTO {
  id: string;
  type: FeedbackType;
}

// ------------ Responses --------------

export interface IGetFeedbacksResponse {
  data: IFeedback[];
  meta: IPagination;
}

export interface IChangeFeedbackStatusResponse {
  data: IFeedback;
}

export interface IGetNewFeedbacksCountResponse {
  data: {
    count: number;
    by_type: Record<FeedbackType, number>;
  };
}
